<template>
  <div>
    <v-dialog
      v-model="dialog"
      v-if="this.selected != null"
      max-width="800px"
    >
      <accessDialog
        eager
        :questionnaire="selected[0]"
        :users="this.users"
        @close-questionnaire-access-dialog="dialog = false"
        @save-questionnaire-access="accessSaved"
      ></accessDialog>
    </v-dialog>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="questionnaireList"
        :loading="loadingQuestionnaires"
        item-key="id"
        class="elevation-1"
        show-expand
        :expanded.sync="questionnaireExpanded"
        v-model="selected"
        @click:row="selectQuestion($event)"
      >
        <template v-slot:top>
          <v-card-title>Questionnaire</v-card-title>
        </template>
        <template v-slot:expanded-item="{headers, item}">
          <td :colspan="headers.length">
            <v-card v-if="questionnaireExpanded" width="100%" class="elevation-10">
              <v-data-table
                :headers="questionHeaders"
                :items="item.questionnaireQuestions"
                item-key="id"
                class="elevation-10"
                show-expand
                width="100%"
                :expanded.sync="questionExpanded"
              >
                <template v-slot:top>
                  <v-card-title>Questions</v-card-title>
                </template>
                <template v-slot:expanded-item="{headers, item}">
                  <td :colspan="headers.length">
                    <v-card v-if="questionExpanded" width="50%" class="elevation-10">
                  <v-data-table
                        :headers="answerHeaders"
                        :items="item.answers"
                        item-key="id"
                        class="elevation-10"
                        width="100%"
                        :sort-by.sync="item.orderNumber">
                        <template v-slot:top>
                          <v-card-title>Answers</v-card-title>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td
                              class="text-xs"
                            >{{ props.item.orderNumber }}</td>
                            <td
                              class="text-xs"
                            >{{ props.item.title }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import accessDialog from '@/components/questionnaire/QuestionnaireAccessDialog'
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  // props: ['auth'],
  props: {
    users: {
      type: Array,
      required: true,
      default: null
    }
  },

  data: () => ({
    model: null,
    dialog: false,
    loadingQuestionnaires: false,
    panel: [[true], [false], [false], [false], [false]],
    rppItems: [
      5,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    questionnaireExpanded: [],
    questionExpanded: [],
    accordion: false,
    selected: [],
    userIds: [],
    headers: [
      {
        text: 'Questionnaire ID',
        value: 'id'
      },
      { text: 'Name', value: 'name' },
      { text: 'Type', value: 'typeCode' },
      { text: 'Description', value: 'description' }
    ],
    questionHeaders: [
      { text: 'Page', value: 'questionPageNumber' },
      { text: 'Number', value: 'questionNumber' },
      { text: 'Question', value: 'question' },
      { text: 'Type', value: 'typeCode' },
      { text: 'Required', value: 'required' }
    ],
    answerHeaders: [
      { text: 'Order', value: 'orderNumber' },
      { text: 'Answer', value: 'title' }
    ],
    questionnaireList: []
  }),

  components: {
    accessDialog
  },

  computed: {},

  watch: {
    dialog (val) {
      val || this.close()
    },
    users: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        if (newValue != null) {
          this.userIds = newValue.map(
            (i) => i.userId
          )
        }
      }
    }
  },
  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.loadingQuestionnaires = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_QUESTIONNAIRES}/questionnaires?active=true`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      this.questionnaireList = getResponse.data
      this.loadingQuestionnaires = false
    },
    close () {

    },
    accessSaved () {
      this.dialog = false
    },
    async selectQuestion (a) {
      this.selected = [a]
      this.dialog = true
    }
  }
}
</script>
